const $document = $(document);

/**
 * Handle Change Image
 */
const handleChangeImage = () => {
  $document.on('change', '.js-pdp-item .js-product-main-select', function() {
    const $this = $(this);
    const $parent = $this.closest('.js-pdp');
    const $imageContainer = $parent.find('.product-item__image');
    const $currentVariant = $this.find('option:selected');
    const image = $currentVariant.data('img-src');

    changeImage($imageContainer, image);
  });
}

/**
 * Change Image
 * @param  {Object} $imageContainer
 * @param  {String} imgSrc
 */
const changeImage = ($imageContainer, imgSrc) => {
  const $imageOverlayTemplate = $(`<img src="${imgSrc}" class="product-item__image-overlay">`);

  // add loader
  $imageContainer.addClass('js-loader');

  // append new image
  $imageOverlayTemplate.appendTo($imageContainer);

  // listener for new image load
  $imageContainer.find('.product-item__image-overlay').on('load', function() {
    // remove old image
    $imageContainer
      .find('img')
      .not('.product-item__image-overlay')
      .remove();

    // remove class on image overlay
    $imageContainer
      .find('.product-item__image-overlay')
      .removeClass('product-item__image-overlay');

    // remove loader
    $imageContainer
      .removeClass('js-loader');
  });
}

handleChangeImage();
